module.exports = __webpack_public_path__ + "img/u927.5432e83b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/price/u927.svg
// module id = 586
// module chunks = 137